import * as P from 'prop-types';
import { TransactionAmountProps } from '@redux/reducers/NewOrderReducer/PropTypes';

export const propTypes = {
  $state: P.shape(TransactionAmountProps).isRequired,
};

export const defaultProps = {};
